// extracted by mini-css-extract-plugin
module.exports = {"root":"GoogleStorageProject-module__root__2ExnT"};